import React, { useState, useEffect, useCallback } from 'react';
import './style.scss';
import Icon from 'react-icons-kit';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { chevronLeft, plus } from 'react-icons-kit/feather';
import Requests from '../../../../utils/Requests/Index';
import LoadingComponent from '../../../../components/loading/Index';

const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [item, setItem] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState(null);
 const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })

  /* ----------------------------------
     Fetch profile data
  -----------------------------------*/
  const fetchData = useCallback(async () => {
    try {
      const data = await Requests.VerificationService.Show(id, header);
      if (data) {
        setItem(data);
        // setItems(Array.isArray(data.features) ? data.features : []);
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [id, header]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Handle image
    const handleImage = async (event) => {
        const file = event.target.files[0]
        if (file) {
            const size = parseInt(file.size) / 1000
            if (size > 800) {
                setError({ ...error, image: 'Select less than 800KB file.' })
                return
            }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })

            let formData = new FormData()
            formData.append('image', file)
            setItem({ ...item, image: null })

            const response = await Requests.VerificationService.UpdateImage(id, formData, header)
            if (response.status === true) {
                toast.success(response.message)
            }
        }
    }

  /* ----------------------------------
     Submit update
  -----------------------------------*/
  const onSubmit = async (data) => {
    try {
      setUpdating(true);

      const payload = {
        ...data 
      };

      await Requests.VerificationService.Update(id, payload, header);
      toast.success('Verification Service updated successfully');
      navigate('/dashboard/website/verification-service');
    } catch (err) {
      console.error(err);
    } finally {
      setUpdating(false);
    }
  };

  if (loading) return <LoadingComponent />;

  return (
    <div className="store-blog pb-4">
      <div className="container-fluid">
        <div className="card border-0 shadow-sm">
          <div className="card-header bg-white p-4 d-flex justify-content-between">
            <h6>Edit Verification Service</h6>
            <Link
              to="/dashboard/website/verification-service"
              className="btn shadow-none rounded-circle"
            >
              <Icon icon={chevronLeft} size={22} />
            </Link>
          </div>

          <div className="card-body p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Name */}
                <div className="col-12 col-lg-6">
                    <div className="form-group mb-4">
                        {errors.name && errors.name.message ? (
                            <p className="text-danger">{errors.name && errors.name.message}</p>
                        ) : <p>Name</p>
                        }

                        <input
                            type="text"
                            name="name"
                            defaultValue={item.name}
                            className="form-control shadow-none"
                            placeholder="Enter Name"
                            {...register("name",{ required: "Name is required" })}
                        />
                    </div>
                </div>

                {/* phone */}
                <div className="col-12 col-lg-6">
                    <div className="form-group mb-4">
                        {errors.phone && errors.phone.message ? (
                            <p className="text-danger">{errors.phone && errors.phone.message}</p>
                        ) : <p>Phone</p>
                        }

                        <input
                            type="text"
                            name="phone"
                            defaultValue={item.phone}
                            className="form-control shadow-none"
                            placeholder="Enter Phone"
                            {...register("phone",{ required: "Phone is required" })}
                        />
                    </div>
                </div>
              </div>

            {/*  */}
            <div className="row">
                {/* package */}
                <div className="col-12 col-md-6">
                    <div className="form-group mb-4">
                        {errors.package && errors.package.message ? (
                            <p className="text-danger">{errors.package && errors.package.message}</p>
                        ) : <p>Package</p>
                        }

                        <input
                            type="text"
                            name="package"
                            className="form-control shadow-none"
                            defaultValue={item?.package}
                            placeholder="Enter Package"
                            {...register("package",{ required: "Package is required" })}
                        />
                    </div>
                </div>

                

                {/* verificationType */}
                <div className="col-12 col-md-6">
                    <div className="form-group mb-4">
                        {errors.verificationType && errors.verificationType.message ? (
                            <p className="text-danger">{errors.verificationType && errors.verificationType.message}</p>
                        ) : <p>Verification Type</p>
                        }

                        <select
                            className="form-control shadow-none"
                            defaultValue={item?.verificationType || ''}
                            {...register('verificationType', {
                                required: 'Verification Type is required',
                            })}
                            >
                            <option value="">-- Select Verification Type --</option>
                            <option value="verified">Verified</option>
                            <option value="not verified">Not Verified</option>
                        </select>
                    </div>
                </div>

                
            </div>

            {/* Image upload Container */}
                            <div className="form-group mb-4">
                                {error && error.image ? <p className="text-danger">{error.image}</p> : <p>Image</p>}
                                <div className="d-flex">
                                    {item && item.image ?
                                        <div className="img-container text-center mr-2">
                                            <div className="image border">
                                                <img src={item.image} className="img-fluid" alt="..." />
                                            </div>
                                        </div>
                                        : selectedFile ?
                                            <div className="img-container text-center mr-2">
                                                <div className="image border">
                                                    <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                </div>
                                            </div>
                                            : null}
            
                                    <div className="img-container text-center">
                                        <div className="image border">
                                            <input type="file" className="upload" onChange={handleImage} />
                                            <div className="flex-center flex-column">
                                                <Icon icon={plus} size={22} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


              <div className="text-end mt-4">
                <button className="btn btn-primary" disabled={updating}>
                  {updating ? 'Updating...' : 'Update'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;


